import { render, staticRenderFns } from "./download-invoice-button.vue?vue&type=template&id=05b5a548"
import script from "./download-invoice-button.vue?vue&type=script&lang=js"
export * from "./download-invoice-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b5a548')) {
      api.createRecord('05b5a548', component.options)
    } else {
      api.reload('05b5a548', component.options)
    }
    module.hot.accept("./download-invoice-button.vue?vue&type=template&id=05b5a548", function () {
      api.rerender('05b5a548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/buttons/download-invoice-button.vue"
export default component.exports